/*
  (c) 2025 Fluxonix Inc. - Fluxonix Hook for Agent Toggling
*/

import { useState } from 'react';
import { api } from '../api';
import { useAuth } from "../auth/AuthProvider";

export function useToggleAgent(setAgents) {
  const { token } = useAuth() || {};
  const [loadingId, setLoadingId] = useState(null);
  const [error, setError] = useState('');

  const toggleAgent = async (name, status) => {
    setError('');
    setLoadingId(name);
    try {
      await api.post(
        `/api/admin/agents/${name}/toggle`,
        { status },
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );

      if (setAgents) {
        setAgents((prev) =>
          prev.map((a) => (a.name === name ? { ...a, status } : a))
        );
      }
    } catch (e) {
      console.error('❌ toggleAgent error:', e);
      setError(e?.message || 'Toggle failed');
    } finally {
      setLoadingId(null);
    }
  };

  return {
    toggleAgent,
    loadingId,
    error,
  };
}
